import { createWithEqualityFn as create } from 'zustand/traditional';

interface Responsive {
    isMobile: boolean;
    setIsMobile: (value: boolean) => void;
    isSidebarCollapsed: boolean;
    setIsSidebarCollapsed: (value: boolean) => void;
    collapsed: string | boolean | null;
    setCollapsed: (value: string | boolean | null) => void;
}

const useResponsive = create<Responsive>(set => ({
    isMobile: false,
    isSidebarCollapsed: false,
    collapsed: false,
    setIsMobile: isMobile => set({ isMobile }),
    setIsSidebarCollapsed: isSidebarCollapsed => set({ isSidebarCollapsed }),
    setCollapsed: collapsed => set({ collapsed }),
}));

export { useResponsive };
export type { Responsive };
